<template>
  <div class="sidebar-left">
    <div class="sidebar">
      <div class="sidebar-content todo-sidebar">
        <div class="todo-app-menu">
          <div class="add-task">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              block
              :disabled="editDisabled"
              @click="$emit('update:command', 'addFolder'); $emit('update:is-task-handler-sidebar-active', true); $emit('close-left-sidebar'); $emit('refresh-list')"
            >
              {{ $t("New folder") }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              block
              :disabled="editDisabled"
              @click="$emit('update:command', 'addFile'); $emit('update:is-task-handler-sidebar-active', true); $emit('close-left-sidebar')"
            >
              {{ $t("Add File") }}
            </b-button>
          </div>
          <vue-perfect-scrollbar
            :settings="perfectScrollbarSettings"
            class="sidebar-menu-list scroll-area"
          >
            <!-- Filters -->
            <b-list-group class="list-group-filters">
              <b-list-group-item
                v-for="filter in taskFilters"
                :key="filter.title + $route.path"
                :to="filter.route"
                :active="isDynamicRouteActive(filter.route)"
                @click="$emit('close-left-sidebar')"
              >
                <feather-icon
                  :icon="filter.icon"
                  size="18"
                  class="mr-75"
                />
                <span class="align-text-bottom line-height-1">{{ filter.title }}</span>
              </b-list-group-item>
              <b-list-group-item
                v-for="file in files"
                :key="file.id"
                :active="isFolderActive(file.id)"
                class="ml-0"
                @click="$emit('update:command', 'enterfolder:'+file.id); "
              >
                <feather-icon
                  v-if="file.type='DIRECTORY'"
                  icon="FolderIcon"
                  size="18"
                  class="mr-75"
                />
                <span
                  v-if="file.type='DIRECTORY'"
                  class="align-text-bottom line-height-1"
                >{{ file.name }}</span>
              </b-list-group-item>
            </b-list-group>

            <!-- Tags -->
            <div
              v-if="showTags"
              class="mt-3 px-2 d-flex justify-content-between"
            >
              <h6 class="section-label mb-1">
                Tags
              </h6>
              <feather-icon icon="PlusIcon" />
            </div>

            <b-list-group
              v-if="showTags"
              class="list-group-labels"
            >
              <b-list-group-item
                v-for="tag in taskTags"
                :key="tag.title + $route.path"
                :to="tag.route"
                :active="isDynamicRouteActive(tag.route)"
                @click="$emit('close-left-sidebar')"
              >
                <span
                  class="bullet bullet-sm mr-1"
                  :class="`bullet-${tag.color}`"
                />
                <span>{{ tag.title }}</span>
              </b-list-group-item>
            </b-list-group>

          </vue-perfect-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {
  BButton, BListGroup, BListGroupItem, BAvatar,
} from 'bootstrap-vue'
import { isDynamicRouteActive } from '@core/utils/utils'
import Ripple from 'vue-ripple-directive'
import i18n from '@/libs/i18n'
import UserService from '@/basic/userService'
import useJwt from '@/auth/jwt/useJwt'
import store from '@/store'
import ability from '@/libs/acl/ability'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
    BListGroup,
    BListGroupItem,
    VuePerfectScrollbar,
    BAvatar,

  },
  props: {
    taskTags: {
      type: Array,
      required: true,
    },
    command: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      showTags: false,
      files: [],
      editDisabled: !ability.can('manage', 'Basic Files'),
    }
  },
  watch: {
    command: {
      handler(newValue) {
        console.log(`left watch command:${newValue}`)
        if (newValue === 'addFolderCompleted') {
          this.refreshFiles()
        } else {
          console.log('no refreshFiles', newValue)
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.refreshFiles()
  },
  methods: {
    refreshFiles() {
      console.log('refreshFiles')
      const userService = new UserService(useJwt)
      const data = {
        folder_id: 0,
      }
      const company_id = store.state.userCompany.id

      userService.files_tree(company_id, data).then(response => {
        this.files = response.data.data.tree[0].children

        console.log('files folder 0', this.files)
      })
    },
    isFolderActive() {
      return false
    },
  },
  setup() {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
    }

    const taskFilters = [
      // {title: 'My Drive', icon: 'FolderIcon', route: {name: 'filefinder'}},
      // { title: 'Important', icon: 'StarIcon', route: { name: 'apps-todo-filter', params: { filter: 'important' } } },
      // { title: 'Completed', icon: 'CheckIcon', route: { name: 'apps-todo-filter', params: { filter: 'completed' } } },
      // { title: 'Deleted', icon: 'TrashIcon', route: { name: 'apps-todo-filter', params: { filter: 'deleted' } } },
    ]

    return {
      perfectScrollbarSettings,
      taskFilters,
      isDynamicRouteActive,
    }
  },
}
</script>

<style>

</style>
